import { render, staticRenderFns } from "./BatchCheck.vue?vue&type=template&id=f23a323e"
import script from "./BatchCheck.vue?vue&type=script&lang=js"
export * from "./BatchCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports